import React, { useState } from 'react';
import './PainPoints.css';
// Paired optical studies: the same business material, before and after clarity.
const ChallengeFlow = ({ kind }) => (
  <span className={`challenge-study study-${kind}`} aria-hidden="true">
    <svg viewBox="0 0 480 150" fill="none">
      <path className="study-divider" d="M240 22v106" />
      {kind === 0 && <>
        <g className="study-muted"><path d="M25 38h64q25 0 25 25v14M40 115h44q20 0 20-19M25 76h46M140 42h38M148 108h38" /><circle cx="25" cy="38" r="4"/><circle cx="40" cy="115" r="4"/><circle cx="25" cy="76" r="4"/></g>
        <path className="study-route" d="M280 38h20q40 0 40 37M280 112h20q40 0 40-37M280 75h172" />
        <circle className="study-lens" cx="340" cy="75" r="24"/><circle className="study-core" cx="340" cy="75" r="5"/><path className="study-route" d="m443 67 9 8-9 8"/>
      </>}
      {kind === 1 && <>
        <path className="study-muted" d="M24 75h43q24 0 24-26t-24-26q-24 0-24 26t24 26h41m28 0h48M156 75v39h-41"/>
        {[24,108,136,184].map(x=><circle key={x} className="study-fragment" cx={x} cy="75" r="7"/>)}
        <path className="study-route" d="M280 75h172"/>
        {[280,360,440].map((x,i)=><g key={x}><circle className={i===1?'study-lens':'study-node'} cx={x} cy="75" r={i===1?24:10}/><circle className="study-core" cx={x} cy="75" r="3"/></g>)}
        <path className="study-route" d="m316 70 6 5-6 5m80-5 6 5-6 5"/>
      </>}
      {kind === 2 && <>
        <g className="study-muted"><path d="M30 105V69m26 20V34m28 82V57m36 40V28m26 87V68m29 21V44"/><circle cx="30" cy="56" r="4"/><circle cx="84" cy="40" r="4"/><circle cx="146" cy="50" r="4"/></g>
        <path className="study-orbit" d="M275 75q82-80 175 0-93 80-175 0Z"/>
        <circle className="study-lens" cx="362" cy="75" r="34"/><path className="study-route" d="m302 91 32-8 28-21 27 8 35-23"/><circle className="study-core" cx="362" cy="62" r="5"/>
      </>}
      {kind === 3 && <>
        <g className="study-muted"><path d="m28 75 76-44M28 75h90M28 75l77 45m33-91 43-15m-37 60h43m-43 41 39 18"/><circle cx="28" cy="75" r="7"/></g>
        <path className="study-route" d="M279 30q54 7 82 45-28 38-82 45M279 75h162"/><circle className="study-lens" cx="401" cy="75" r="34"/><circle className="study-orbit" cx="401" cy="75" r="20"/><circle className="study-core" cx="401" cy="75" r="6"/>
      </>}
    </svg>
  </span>
);
const challenges = [
  { title: 'Enquiries come in. Follow-ups slip.', problem: 'WhatsApp, calls and DMs multiply as you grow.', from: 'Scattered leads. Late replies.', to: 'One pipeline. A clear next step.', tone: 'red' },
  { title: 'Everyone is busy. Work still gets stuck.', problem: 'Manual updates and unclear handoffs stretch your team.', from: 'Repeated work. Unclear ownership.', to: 'Connected steps. Accountable owners.', tone: 'yellow' },
  { title: 'More data. No clearer picture.', problem: 'Reports sit in different tools when you need a decision.', from: 'Disconnected numbers. Guesswork.', to: 'One useful view. Informed decisions.', tone: 'yellow' },
  { title: 'Marketing goes out. Growth is hard to see.', problem: 'More activity does not always mean more customers.', from: 'Scattered campaigns. Unclear returns.', to: 'Focused messaging. Measurable response.', tone: 'red' }
];
const PainPoints = () => {
  const [active, setActive] = useState(0);
  return (
    <section className="pain-points" aria-labelledby="pain-points-title">
      <div className="container">
        <div className="pain-points-heading-wrap">
          <h2 id="pain-points-title">Are you facing these<br /><em>everyday challenges?</em></h2>
          <p>Growing businesses feel the friction before they can name the fix.</p>
        </div>
        <div className="challenge-grid" aria-label="Everyday business challenges">
          {challenges.map((item, index) => (
            <button type="button" key={item.title} className={`challenge-card ${item.tone} ${active === index ? 'active' : ''}`} aria-pressed={active === index} onClick={() => setActive(index)}>
              <span className="challenge-top"><span>0{index + 1}</span><span className="challenge-cue">{['Gather the signal', 'Connect the work', 'Bring it into focus', 'Give growth direction'][index]}</span></span>
              <span className="challenge-title">{item.title}</span>
              <span className="challenge-problem">{item.problem}</span>
              <ChallengeFlow key={`${index}-${active === index}`} kind={index} /><span className="challenge-shift"><span><small>From</small>{item.from}</span><span className="challenge-arrow" aria-hidden="true">&rarr;</span><span><small>To</small>{item.to}</span></span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};
export default PainPoints;
